import { html, nothing, TemplateResult } from 'lit-html';
import { InputComponent, ButtonComponent, LabelComponent } from '@components/common';

export const LocationTypeaheadTemplate = (props: ILocationTypeaheadProps, handlers: ILocationTypeaheadEventHandlers): TemplateResult => {

  const {
    labelText,
    cssClasses,
    placeholder,
    locationValue,
    locationTypeaheadFor,
    elementName = 'where',
    clearButtonEnabled = true,
  } = props;
  const {
    handleKeyDown,
    handleInputChange,
    handleClearWhereInput
  } = handlers;

  return html`
    <div class="typeahead-wrapper">
    ${InputComponent({
    type: 'text',
    name: elementName,
    value: locationValue,
    cssClasses,
    placeholder,
    eventHandlers: {
      onInput: handleInputChange,
      onKeyDown: handleKeyDown
    },
    options: {
      tabIndex: '-1',
      autoComplete: 'off'
    }
  })}
  ${clearButtonEnabled ? ButtonComponent({
    type: 'button',
    cssClasses: 'clear-button',
    eventHandlers: {
      onClick: handleClearWhereInput
    }
  }) :
      nothing}
    ${LabelComponent({
        labelText,
        cssClasses: 'proposal-form__label'
      })}
    <div class="suggested-location ts-suggested-location-${locationTypeaheadFor}"></div>
  </div>
  `;
}